import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgActiveTrue = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 12q.907 0 1.554-.646.647-.645.646-1.554 0-.909-.646-1.553A2.13 2.13 0 0 0 12 7.6a2.1 2.1 0 0 0-1.553.647A2.14 2.14 0 0 0 9.8 9.8a2.1 2.1 0 0 0 .647 1.554q.649.65 1.553.646m0 8.085q3.355-3.08 4.977-5.596T18.6 10.02q0-2.997-1.91-4.908Q14.777 3.202 12 3.2q-2.778 0-4.688 1.912T5.4 10.02q0 1.952 1.622 4.47Q8.645 17.005 12 20.084M12 23q-4.428-3.768-6.613-6.998T3.2 10.02q0-4.124 2.654-6.572T12 1q3.492 0 6.147 2.448T20.8 10.02q0 2.75-2.186 5.982Q16.428 19.233 12 23"
      />
    </svg>
  );
};
export default SvgActiveTrue;
